import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalAlreadyCheckedOutError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalAlreadyCheckedOutError';
  }
}
